// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__svE6d","container":"styles_container__1Hw35","title":"styles_title__yZpCm","wrapper":"styles_wrapper__2T-B-","answer":"styles_answer__1aUtw"};